import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLink24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLink24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 12a4.75 4.75 0 0 1 4.75-4.75h2a.75.75 0 0 1 0 1.5h-2a3.25 3.25 0 0 0 0 6.5h2a.75.75 0 0 1 0 1.5h-2A4.75 4.75 0 0 1 2 12m20 0a4.75 4.75 0 0 1-4.75 4.75h-2a.75.75 0 0 1 0-1.5h2a3.25 3.25 0 0 0 0-6.5h-2a.75.75 0 0 1 0-1.5h2A4.75 4.75 0 0 1 22 12m-13.75-.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLink24);
